import type { NeuronId, SerialNumber } from "~domain/devices/models/common-device-model.ts";
import type { ModulatorLinkCsId, ModulatorLinkHwId } from "~domain/devices/models/links/link-model.ts";
import type { ModulatorCsId, ModulatorHwId } from "~domain/devices/models/modulators/modulator-model.ts";
import type { ModulatorTypeId } from "~domain/devices/models/modulators/modulator-type-model.ts";
import type { PilotCsId, PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";
import type { OperatorId } from "~domain/operators/models/operator-model.ts";
import type { SiteId } from "~domain/sites/models/site-model.ts";

import { z } from "zod";

export const backofficeFindSiteModulatorsResponseSchema = z
  .object({
    creationDatetime: z.coerce.date(),
    links: z.array(
      z.object({
        appliances: z.array(
          z.object({
            appliance: z.object({
              description: z.string(),
              id: z.number(),
              translation: z.string(),
            }),
            creationDatetime: z.coerce.date(),
            csLinkId: z.number().transform((s) => s as ModulatorLinkCsId),
            description: z.string().nullable(),
            hwLinkId: z.number().transform((s) => s as ModulatorLinkHwId),
            id: z.number().nullable(), // ?????
            isProducer: z.boolean(),
            lastModificationDatetime: z.coerce.date().nullable(),
            localisation: z.string().nullable(),
            nominalPower: z.number().nullable(),
            personCreationId: z
              .number()
              .transform((s) => s as OperatorId)
              .nullable(),
            personModificationId: z
              .number()
              .transform((s) => s as OperatorId)
              .nullable(),
            producer: z.boolean(),
          }),
        ),
        csId: z.number().transform((s) => s as ModulatorLinkCsId),
        csLinkToCutId: z
          .number()
          .transform((s) => s as ModulatorLinkCsId)
          .nullable(),
        cutLink: z.boolean(),
        hwId: z.number().transform((s) => s as ModulatorLinkHwId),
        interfaceName: z.string().nullable(),
        isGlobal: z.boolean(),
        isUpdated: z.boolean(),
        measureIndex: z.number(),
        measureType: z.number(),
        numInterface: z.number(),
      }),
    ),
    csId: z
      .number()
      .transform((s) => s as ModulatorCsId)
      .nullable(),
    hwId: z.number().transform((s) => s as ModulatorHwId),
    location: z.string().nullable(),
    modnum: z.number().nullable(),
    momboxCsId: z
      .number()
      .transform((s) => s as PilotCsId)
      .nullable(),
    momboxId: z
      .number()
      .transform((s) => s as PilotHwId)
      .nullable(),
    neuronId: z.string().transform((s) => s as NeuronId),
    pairingStatus: z.any(), // TODO: check what it is
    refOperatingStatus: z.number(), // TODO: check what it is
    serialNumber: z
      .string()
      .nullable()
      .transform((s) => s as SerialNumber),
    siteId: z.number().transform((s) => s as SiteId),
    type: z.object({
      id: z.number().transform((s) => s as ModulatorTypeId),
      label: z.string(),
      measurementType: z.any().nullable(), // TODO: check what it is
      measurementUnit: z.any().nullable(), // TODO: check what it is
      meter: z.boolean(),
      modbus: z.boolean(),
      nbMeasure: z.number(),
      nbTinf: z.number(),
      note: z.string(),
      v2V5: z.boolean(),
      value: z.number(),
      vx: z.boolean(),
      vxRelay: z.boolean(),
      vxWire: z.boolean(),
      zigbeeStandard: z.boolean(),
    }),
  })
  .array();

export type BackofficeFindSiteModulatorsResponse = z.infer<typeof backofficeFindSiteModulatorsResponseSchema>;
